import React from 'react'
import Collapsible from 'react-collapsible'
import PropTypes from 'prop-types'

class CFXProReactCollapsible extends React.Component {
  render() {
    const {title, transitionTime = null, easing = null, ...rest} = this.props

    return (
      <Collapsible
        trigger={cfxProCollapsibleTriggerElement(title)}
        transitionTime={transitionTime != null ? transitionTime : 200}
        easing={easing != null ? easing : 'ease-out'}
        {...rest}
      >
        {this.props.children}
      </Collapsible>
    )
  }
}

CFXProReactCollapsible.propTypes = {
  title: PropTypes.string.isRequired,
  transitionTime: PropTypes.number,
  easing: PropTypes.string,
}

export default CFXProReactCollapsible

const cfxProCollapsibleTriggerElement = (title) => (
  <div>
    <span>{title}</span>
    <i className="Collapsible__trigger-icon fa fa-angle-down" />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/cfxProReactCollapsible.js